import { useQuery } from 'react-query';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getCompanyBuyers } from 'services/CompanyService';
import { SortByOption } from '../types';
import { SortDirection } from 'components/Table/types';

export const useGetCompanyBuyers = (
  page: number,
  perPage: number,
  searchBy: string,
  sortBy: SortByOption,
  sortDirection: SortDirection
) =>
  useQuery({
    queryKey: [
      ReactQueryKeys.GET_COMPANY_BUYERS,
      page,
      perPage,
      searchBy,
      sortBy,
      sortDirection,
    ],
    queryFn: () => {
      return getCompanyBuyers(page, perPage, searchBy, sortBy, sortDirection);
    },
  });
